var i18n = require("react-i18next");

exports.useTranslation = (ns) => () => {
  const { t } = i18n.useTranslation(ns);

  return t;
};
